import { useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'utilities/hooks';
import { resetCurrentTeam, setCurrentTeam } from 'slices/teamsSlice';
import { useModeDocumentsPage } from './useModeDocumentsPage';
import { ModeDocumentsPageType } from '../types';
import { clearParams } from '../slices/documentsSlice';
import { fetchDocuments } from 'slices/documentsActions';

export const useDocumentsNavigateTo = (mode: ModeDocumentsPageType = 'documents') => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { isShared } = useModeDocumentsPage(mode);

    const { currentTeam } = useAppSelector((state) => state.teams);
    const { listDocuments, teams } = useAppSelector((state) => state.documents);
    const location = useLocation();
    const navigateTo = (categoryId: number | null = null) => {
        dispatch(clearParams());

        let to = isShared ? '/documents/shared' : '/documents';
        if (categoryId) to += `/${categoryId}`;
        if (location.pathname === to) {
            dispatch(fetchDocuments(categoryId ?? null));
            return
        }

        if (isShared && !currentTeam && categoryId && teams) {
            let category = listDocuments.find((item: { id: number; uuid: string }) => item.id === categoryId);

            if (category) {
                let team = teams[category.uuid];
                if (team) dispatch(setCurrentTeam(team));
            }
        } else if (isShared && currentTeam && !categoryId) {
            dispatch(resetCurrentTeam());
        }

        navigate(to);
    };

    return {
        navigateTo,
    };
};
